import styled from 'styled-components';
import { lightGrey2Color } from 'js/config/style';

export default styled.div`
  grid-area: status;

  & > div {
    display: inline-block;
    font-size: 0.8rem;
    padding: 0.25rem 0.5rem;
    border-radius: 0.25rem;
    border: 1px solid ${lightGrey2Color};
    margin-top: 0.25rem;
    background: white;
  }
`;
